import type { Facettes, RequeteRecherche, Segment } from "@sfs/contracts";

type Props = {
  filtres: Partial<RequeteRecherche>;
  setFiltres: (f: Partial<RequeteRecherche>) => void;
  facettes?: Facettes;
};

/** Les compteurs viennent d'une vue matérialisée : agréger 1 M de lignes à chaque frappe est impossible. */
export function PanneauFacettes({ filtres, setFiltres, facettes }: Props) {
  const basculerTableau = (cle: "codesNaf" | "departements", valeur: string) => {
    const actuel = (filtres[cle] as string[]) ?? [];
    setFiltres({ ...filtres, [cle]: actuel.includes(valeur) ? actuel.filter(v => v !== valeur) : [...actuel, valeur] });
  };

  const basculerSegment = (s: Segment) => {
    const actuel = filtres.segments ?? [];
    setFiltres({ ...filtres, segments: actuel.includes(s) ? actuel.filter(v => v !== s) : [...actuel, s] });
  };

  return (
    <aside className="facettes">
      <fieldset>
        <legend>Segment</legend>
        {(["A", "B", "C"] as Segment[]).map(s => (
          <label key={s} className="c">
            <input type="checkbox" checked={filtres.segments?.includes(s) ?? false} onChange={() => basculerSegment(s)} />
            <span className={`seg ${s}`}>{s}</span>
            {s === "A" ? "prioritaire" : s === "B" ? "à travailler" : "ne pas prospecter"}
            <span className="cnt">{facettes?.segments.find(f => f.valeur === s)?.nb.toLocaleString("fr-FR") ?? "—"}</span>
          </label>
        ))}
      </fieldset>

      <fieldset>
        <legend>Score minimum — {filtres.scoreMin ?? 0}</legend>
        <input type="range" min={0} max={100} step={5} value={filtres.scoreMin ?? 0}
               onChange={e => setFiltres({ ...filtres, scoreMin: Number(e.target.value) })} />
      </fieldset>

      <fieldset>
        <legend>Secteur</legend>
        {(facettes?.codesNaf ?? []).slice(0, 8).map(f => (
          <label key={f.valeur} className="c">
            <input type="checkbox" checked={filtres.codesNaf?.includes(f.valeur) ?? false}
                   onChange={() => basculerTableau("codesNaf", f.valeur)} />
            {f.libelle || f.valeur}
            <span className="cnt">{f.nb.toLocaleString("fr-FR")}</span>
          </label>
        ))}
      </fieldset>

      <fieldset>
        <legend>Département</legend>
        {(facettes?.departements ?? []).slice(0, 10).map(f => (
          <label key={f.valeur} className="c">
            <input type="checkbox" checked={filtres.departements?.includes(f.valeur) ?? false}
                   onChange={() => basculerTableau("departements", f.valeur)} />
            {f.valeur}
            <span className="cnt">{f.nb.toLocaleString("fr-FR")}</span>
          </label>
        ))}
      </fieldset>

      <fieldset>
        <legend>Fraîcheur</legend>
        <label className="c">
          <input type="checkbox" checked={filtres.masquerPerimees ?? false}
                 onChange={e => setFiltres({ ...filtres, masquerPerimees: e.target.checked })} />
          Masquer les fiches de plus de 90 jours
        </label>
      </fieldset>
    </aside>
  );
}
